import {
  CountryListRoute,
  AirportListRoute,
  UserListRoute,
  AirlineListRoute,
  CurrencyListRoute,
  CityListRoute,
  TimeTableTemplateParseRoute,
  AirBookingTemplateParseRoute,
  TimeTableTemplateListRoute,
  CounterpartyListRoute,
  AirBookingListRoute,
  AirplaneListRoute,
  TripListRoute,
  AirBookingReportRoute,
  TripItemListRoute,
  AirBookingTemplateListRoute,
  AirBookingCreateRoute,
  OfferListRoute,
  DebtorCompareRoute,
  TripUsersRoute,
  ReviseSortRoute,
  ParsersCheckListRoute,
  RailListRoute,
  TouristServicesListRoute,
  RacoonFastRoute,
  SalesRegisterListRoute,
  CounterpartiesFinderRoute,
  DocumentsListRoute,
  CounterpartiesContacts,
  PaxActivityRoute,
  TuesdayRoute,
  IncomeRoute,
  IncomeReportRoute,
  AllIncomeRoute,
  CheckRoute,
  OSVRoute,
  OSVBySupplierRoute,
  ConsumptionRoute,
  RacoonGroupListRoute,
  RacoonGroupReviseRoute,
  TiedUpTicketsRoute,
  TripCheckListRoute,
  RacoonSupplierListRoute,
  FindHotelRoute, RacoonEInvoicesRoute, RacoonRustarPaymensRoute, OSVWSIncomeRoute, AnalyzeKRSRoute, GlobalReportRoute
} from "./routesConstants";


export default user => {
  const rendertiedUpTickets = () =>{
    const res = [];
    if (
      user &&
      user.roles &&
      (user.roles.indexOf("admin") !== -1 ||
        user.roles.indexOf("superAdmin") !== -1)
    ) {
      res.push({
        title: "Подвязки",
        root: true,
        bullet: "dot",
        page: TiedUpTicketsRoute.slice(1),
      });
    }
    return res
  }
  const renderTours = () =>{
    const res = [
      { section: "Туры" },
      {
        title: "Поездки",
        bullet: "dot",
        root: true,
        page: TripListRoute.slice(1),
        icon: "flaticon2-photograph",
      },
      {
        title: "Предложения",
        bullet: "dot",
        root: true,
        icon: 'flaticon2-contract',
        page: OfferListRoute.slice(1)
      },
      {
        title: "Элементы",
        bullet: "dot",
        root: true,
        icon: 'flaticon2-hospital',
        page: TripItemListRoute.slice(1)
      },
      {
        title: "Пользователи",
        bullet: "dot",
        root: true,
        icon: "flaticon2-calendar-3",
        page: TripUsersRoute.slice(1)
      },
    ];
    return res
  }

  const renderIncome = () =>{
    if(user.roles.includes("incomeReport")){
      return [
        {
          title: "Доход",
          bullet: "dot",
          root: true,
          page: "",
          icon: 'flaticon-black',
          submenu: [
            {
              title: "Только крс",
              bullet: "dot",
              page: IncomeRoute.slice(1)
            },
            {
              title: "Подробный",
              bullet: "dot",
              page: AllIncomeRoute.slice(1)
            },
            {
              title: "Отчет",
              bullet: "dot",
              page: IncomeReportRoute.slice(1)
            },
          ]
        },
        {
          title: "Большой отчет",
          bullet: "dot",
          root: true,
          page: GlobalReportRoute.slice(1),
          icon: 'flaticon2-infographic'
        },
      ]
    } else{
      return []
    }


  }
  const getDataLinks = () => {
    const res = [];
    if (
      user &&
      user.roles &&
      (user.roles.indexOf("admin") !== -1 ||
        user.roles.indexOf("superAdmin") !== -1)
    ) {
      res.push({
        title: "Пользователи",
        root: true,
        bullet: "dot",
        page: UserListRoute.slice(1),
        icon: "flaticon2-user"
      });
      res.push({
        title: "Валюты",
        root: true,
        bullet: "dot",
        page: CurrencyListRoute.slice(1),
        icon: "flaticon-price-tag"
      });
      res.push({
        title: "Документы",
        root: true,
        bullet: "dot",
        page: DocumentsListRoute.slice(1),
        icon: "flaticon-interface-3"
      },
        )
    }
    if (
      user.email === "ykarmakov@gmail.com" ||
      user.email === "unoegohh@gmail.com"
    ) {
      res.push({
        title: "Сравнение должников",
        root: true,
        bullet: "dot",
        page: DebtorCompareRoute.slice(1),
        icon: "flaticon2-user"
      });
    }
    return res;
  };
  if(user &&
    user.roles &&
    user.roles.indexOf("employee") === -1 && user.roles.indexOf("toursUser") !== -1
  ){
    return {aside:
    {
      self: {},
      items: [
        ...renderTours(),
        { section: "Услуги" },
        {
          title: "Туристические услуги",
          bullet: "dot",
          root: true,
          page: TouristServicesListRoute.slice(1),
          icon: 'flaticon2-gift-1'
        },

      ]
    }}
  }
  return {
    aside: {
      self: {},
      items: [
        {
          title: "Главная",
          root: true,
          icon: "flaticon2-architecture-and-city",
          page: "",
          bullet: "dot"
        },
        {
          title: "Разное",
          root: true,
          bullet: "dot",
          page: '',
          icon: "flaticon-more",
          submenu: [
            {
              title: "Задачи",
              bullet: "dot",
              page: TuesdayRoute.slice(1),
            },
            {
              title: "Требует проверки",
              bullet: "dot",
              page: CheckRoute.slice(1),
            },
            ...rendertiedUpTickets()
          ]},

        { section: "Бронирования" },
        {
          title: "Загрузить",
          bullet: "dot",
          icon: "flaticon-event-calendar-symbol",
          root: true,
          page: AirBookingCreateRoute.slice(1)
        },
        {
          title: "Список",
          desc: "Список авиабронирований",
          bullet: "dot",
          root: true,
          page: AirBookingListRoute.slice(1),
          icon: 'flaticon2-list-1'
        },
        {
          title: "Отчет",
          bullet: "dot",
          root: true,
          page: AirBookingReportRoute.slice(1),
          icon: 'flaticon2-infographic'
        },
        {
          title: "ЖД",
          bullet: "dot",
          root: true,
          page: RailListRoute.slice(1),
          icon: 'flaticon2-lorry'
        },
        {
          title: "Туристические услуги",
          bullet: "dot",
          root: true,
          page: TouristServicesListRoute.slice(1),
          icon: 'flaticon2-gift-1'
        },
        {
          title: "Чек-лист услуг",
          bullet: "dot",
          root: true,
          page: TripCheckListRoute.slice(1),
          icon: 'flaticon-event-calendar-symbol'
        },
        {
          title: "Активность туриста",
          bullet: "dot",
          root: true,
          page: PaxActivityRoute.slice(1),
          icon: 'flaticon-calendar-with-a-clock-time-tools'
        },
        {
          title: "Анализ крс",
          bullet: "dot",
          root: true,
          page: AnalyzeKRSRoute.slice(1),
          icon: 'flaticon2-infographic'
        },

        { section: "Парсеры" },
        {
          title: "Парс авиа",
          root: true,
          page: AirBookingTemplateParseRoute.slice(1),
          icon: "flaticon2-reload",
        },
        {
          title: "Парс расписания",
          root: true,
          page: TimeTableTemplateParseRoute.slice(1),
          icon: "flaticon2-refresh",
        },
        {
          title: "Разное",
          root: true,
          bullet: "dot",
          page: '',
          icon: "flaticon-more",
          submenu: [
            {
              title: "Парс ошибок",
              bullet: "dot",
              page: ParsersCheckListRoute.slice(1),
            },
            {
              title: "Шаблон авиа бронирования",
              bullet: "dot",
              page: AirBookingTemplateListRoute.slice(1)
            },
            {
              title: "Шаблон расписания",
              bullet: "dot",
              page: TimeTableTemplateListRoute.slice(1)
            }
          ]
        },
        { section: "1C данные" },
        {
          title: "ОСВ",
          root: true,
          bullet: "dot",
          page: '',
          icon: "flaticon-menu-1",
          submenu: [
            {
              title: "ОСВ",
              bullet: "dot",
              page: OSVRoute.slice(1),
            },
            {
              title: "По поставщику(beta)",
              bullet: "dot",
              page: OSVBySupplierRoute.slice(1),
            },
            {
              title: "Осв и доход Аруана",
              bullet: "dot",
              page: OSVWSIncomeRoute.slice(1),
            },
          ]
        },
        {
          title: "Реестр продаж",
          bullet: "dot",
          root: true,
          page: SalesRegisterListRoute.slice(1),
          icon: 'flaticon2-line-chart'
        },
        ...renderIncome(),
        {
          title: "Расходы",
          bullet: "dot",
          root: true,
          page: ConsumptionRoute.slice(1),
          icon: 'flaticon2-sort-down'
        },
        ...renderTours(),

        { section: "Данные" },
        {
          title: "Локации",
          root: true,
          bullet: "dot",
          page: "",
          icon: "flaticon2-map",
          submenu: [
            {
              title: "Страны",
              desc: "Список стран",
              bullet: "dot",
              page: CountryListRoute.slice(1)
            },
            {
              title: "Города",
              desc: "Список стран",
              bullet: "dot",
              page: CityListRoute.slice(1)
            },
            {
              title: "Аэропорты",
              bullet: "dot",
              page: AirportListRoute.slice(1)
            }
          ]
        },
        {
          title: "Авиа",
          root: true,
          bullet: "dot",
          page: '',
          icon: "flaticon2-paper-plane",
          submenu: [
            {
              title: "Авиакомпании",
              root: true,
              bullet: "dot",
              page: AirlineListRoute.slice(1),
            },
            {
              title: "Самолеты",
              root: true,
              bullet: "dot",
              page: AirplaneListRoute.slice(1),
            },
          ]
        },
        {
          title: "Контрагенты",
          root: true,
          bullet: "dot",
          page: '',
          icon: "flaticon-rocket",
          submenu: [
            {
              title: "Контрагенты",
              root: true,
              bullet: "dot",
              page: CounterpartyListRoute.slice(1),
            },
            {
              title: "Клиенты",
              root: true,
              bullet: "dot",
              page: CounterpartiesContacts.slice(1),
            },
            {
              title: "Пассажир-Контрагент",
              root: true,
              bullet: "dot",
              page: CounterpartiesFinderRoute.slice(1),
            },
          ]
        },

        {
          title: "Сверки",
          root: true,
          bullet: "dot",
          page: "",
          icon: "flaticon2-layers",
          submenu: [
            {
              title: "Отчеты",
              bullet: "dot",
              page: ReviseSortRoute.slice(1)
            },
            // {
            //   title: "По выписаным билетам",
            //   bullet: "dot",
            //   page: RacoonTicketParser.slice(1)
            // },
            {
              title: "Быстрая Сверка",
              bullet: "dot",
              page: RacoonFastRoute.slice(1)
            },
            {
              title: "Группы",
              bullet: "dot",
              page: RacoonGroupListRoute.slice(1)
            },
            {
              title: "Поставщик",
              bullet: "dot",
              page: RacoonSupplierListRoute.slice(1)
            },
            {
              title: "ЭСФ",
              bullet: "dot",
              page: RacoonEInvoicesRoute.slice(1)
            },
            {
              title: "Оплаты Рустар",
              bullet: "dot",
              page: RacoonRustarPaymensRoute.slice(1)
            },
          ]
        },

        ...getDataLinks(),
      ]
    }
  };
};
